import React from "react";
import { Role } from "./common/constant";
import { Icon } from "@chakra-ui/react";
import {
  MdHome
} from "react-icons/md";
import CryptoDeposit from "./views/non-auth/CryptoDeposit";
import CryptoTransactionDetail from "./views/non-auth/CryptoTransactionDetail";
import Callback from "./views/non-auth/Callback";

/// <summary>
/// Author: -
/// </summary>
export class WebUrl {
  static _DEFAULT = '';
  static _TRANSACTION_INIT = '/transaction/init';
  static _CALLBACK = '/callback';
}

/// <summary>
/// Author: -
/// </summary>
export const _NON_AUTH_ROUTES = [
  {
    name: "FiPay",
    path: WebUrl._DEFAULT,
    component: <CryptoDeposit />,
  },
  {
    name: "TRANSACTION_DETAIL",
    path: WebUrl._TRANSACTION_INIT,
    component: <CryptoTransactionDetail />,
  },
  {
    name: "CALLBACK",
    path: WebUrl._CALLBACK,
    component: <Callback />,
  }
]

/// <summary>
/// Author: -
/// </summary>
export const _AUTH_ROUTES = [

];
